module.exports = __webpack_public_path__ + "img/image.4e92bf3a.png";